import { Dialog, DialogActions, DialogTitle, Button, DialogContent } from '@mui/material';
import { MutableRefObject, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloseMaintenanceForm from '../../../inventory/Ticketing/maintenance/CloseMaintenanceForm';
import { maintenanceService } from 'services/api';

interface CloseMaintenanceDialogProps {
  closeDialog?: () => void;
  open?: boolean;
  datagridRefresh?: MutableRefObject<any>;
  id?: number;
}

export default function CloseMaintenanceDialog(params: CloseMaintenanceDialogProps) {
  const { datagridRefresh, id, closeDialog, open } = params;
  const { t } = useTranslation();
  const translationPrefix = 'entities.equipment';

  const closeMaintenance = (values) => {
    maintenanceService.closeMaintenance(id, values).then(() => {
      datagridRefresh.current();
    });
    closeDialog();
  };

  return (
    <>
      <Dialog open={open} maxWidth="lg" fullWidth>
        <DialogTitle>{t(`${translationPrefix}.close`)}</DialogTitle>
        <DialogContent>
          <CloseMaintenanceForm onSubmit={closeMaintenance} />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} color="error">
            {t('actions.cancel')}
          </Button>
          <Button type="submit" form="closeMaintenance">
            {t(`actions.confirm`)}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
